import { render, staticRenderFns } from "./ElectronSetup.vue?vue&type=template&id=59d512d7&"
import script from "./ElectronSetup.vue?vue&type=script&lang=js&"
export * from "./ElectronSetup.vue?vue&type=script&lang=js&"
import style0 from "./ElectronSetup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports